
/**
 * 半透明遮罩(弹出框)
 */
export default function TranslucencyMask(props: { closeHandler ?: () => void, className ?: string, children: any}){
    
    const { closeHandler = null, children, className = '' }= props ;

    return (
        <div className={`fixed left-0 top-0 w-full h-full bg-[#000000]/[0.5] ${className}`}
            onMouseMove={(e: React.MouseEvent<HTMLDivElement>) => {e.stopPropagation();}}
            onClick={() => closeHandler && closeHandler()}>
            {children}
        </div>
    )
}